import * as Common from '@/assets/js/common.js'
import { needTranslate } from '@/extend/Util.js'
// import { mapState } from 'vuex'

function setPageTitle(displayName) {
	const title = needTranslate() ? window.AllBridge.t(displayName) : displayName
	document.title = title
}

export default {
	props: ['params'],
	data() {
		return {}
	},
	beforeCreate() {},
	created() {
		this.Common = Common
	},
	beforeMount() {},
	mounted() {},
	activated() {
		const me = this
		if (this.$options.pageName) {
			setPageTitle(this.$options.pageName)
		}
	},
	deactivated() {},
	beforeDestroy() {},
	destroyed() {},

	methods: {
		setPageTitle,
		needTranslate,
	},
}
